import { render, staticRenderFns } from "./CtrlProvedoresPage.vue?vue&type=template&id=7d547664"
import script from "./CtrlProvedoresPage.vue?vue&type=script&lang=js"
export * from "./CtrlProvedoresPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports